import { doGet, doPost, doPut } from 'api/request';
import type { TuningSetting } from 'api/types';
import { LOGGER_TYPE } from 'api/types';
import type {
  AudioGenerationConfig,
  AudioGenerationResponse,
  GenerateAudioPayload,
} from './types';

export const editVoiceTuningSettings = ({
  accountId,
  projectId,
  voiceId,
  settings,
  disclaimer,
}: {
  accountId: string;
  projectId: string;
  voiceId: string;
  settings: TuningSetting;
  disclaimer: boolean;
}) => {
  const basePath = `accounts/${accountId}/projects/${projectId}/voices/${voiceId}`;
  const disclaimerPath = `${basePath}/disclaimer`;

  return doPut<TuningSetting>(
    disclaimer ? disclaimerPath : basePath,
    LOGGER_TYPE.JUPITER,
    {
      similarity_boost: settings.similarity_boost,
      stability: settings.stability,
      model_id: settings.model_id,
      // only include speed if it's defined
      ...(settings.speed !== undefined && {
        speed: settings.speed,
      }),
    },
    { version: 'v2' },
  );
};

export const generateAudio = ({
  accountId,
  projectId,
  provider,
  text,
  language,
  config,
}: {
  accountId: string;
  projectId: string;
  provider: string;
  text: string;
  language: string;
  config: AudioGenerationConfig;
}) => {
  const path = `accounts/${accountId}/projects/${projectId}/generate-audio`;
  const payload: GenerateAudioPayload = {
    provider,
    text,
    config,
    language,
    store_on_s3: true,
  };

  return doPost<AudioGenerationResponse>(path, LOGGER_TYPE.JUPITER, payload, {
    version: 'v2',
  });
};

export const getVoiceTuningSettings = ({
  accountId,
  projectId,
  voiceId,
  purpose,
}: {
  accountId: string;
  projectId: string;
  voiceId: string | undefined | null;
  purpose?: string;
}) => {
  const path = `accounts/${accountId}/projects/${projectId}/voices/${voiceId}/tuning-settings`;
  return doGet<TuningSetting>(path, LOGGER_TYPE.JUPITER, {
    params: {
      purpose: purpose,
    },
    version: 'v2',
  });
};
